module.exports = __webpack_public_path__ + "static/media/cross.dc8a2982.png";